/*
 *==================================================
 * Licensed Materials - ADIACENT
 *
 * CR022 Autodesk Vault - CAD Download Basket
 *
 *==================================================
 */
import Axios, { AxiosPromise } from "axios";

const cadBasketService = {

    getBasket(storeId: string): AxiosPromise<any> {
    return Axios.get(`/wcs/resources/store/${storeId}/cadbasket`);
  },

    addItem(storeId: string, materialPartNum: string,
      excludedAttachmentIds?: string[]): AxiosPromise<any> {
    const body: any = { materialPartNum: materialPartNum };
    if (excludedAttachmentIds && excludedAttachmentIds.length > 0) {
      /** CSV of ATCHAST_IDs the engineer excluded from the ZIP request */
      body.excludedAttachmentIds = excludedAttachmentIds.join(",");
    }
    return Axios.post(`/wcs/resources/store/${storeId}/cadbasket/items`, body);
  },

    removeItemById(storeId: string, itemId: string): AxiosPromise<any> {
    return Axios.delete(`/wcs/resources/store/${storeId}/cadbasket/items/${itemId}`);
  },

    removeItemByPartNum(storeId: string, materialPartNum: string): AxiosPromise<any> {
    return Axios.delete(`/wcs/resources/store/${storeId}/cadbasket/items?materialPartNum=${encodeURIComponent(materialPartNum)}`);
  },

    emptyBasket(storeId: string): AxiosPromise<any> {
    return Axios.delete(`/wcs/resources/store/${storeId}/cadbasket`);
  },

    requestZip(storeId: string): AxiosPromise<any> {
    return Axios.post(`/wcs/resources/store/${storeId}/cadbasket/zip`);
  },
};

export default cadBasketService;
